export default "__VITE_ASSET__BCPPz_Gv__"